import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import founderImg from "../../assets/deepika1.png"; 
import img1 from "../../assets/founder1.jpeg";
import img2 from "../../assets/founder2.jpeg";
import img3 from "../../assets/founder3.jpeg";
import img4 from "../../assets/founder4.jpeg";
import img5 from "../../assets/founder5.jpeg";
import img6 from "../../assets/founder6.jpeg";
import img7 from "../../assets/founder7.jpeg";
import img8 from "../../assets/founder8.jpeg";
import img9 from "../../assets/founder9.jpeg";




const galleryImages = [img1, img2, img3, img4, img5, img6, img7, img8, img9,  ];

const Founder = () => {

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <section className="w-full bg-gray-100" data-aos="fade-up">
      <div className="max-w-6xl px-4 sm:px-6 md:px-12 py-8 sm:py-10 md:py-12 flex flex-col lg:flex-row items-start gap-6 md:gap-10">

        {/* Left side - Profile Image */}
        <div className="w-full lg:w-1/3 flex justify-center">
          <img
            src={founderImg}
            alt="Dr. Deepika"
            className="object-cover w-48 sm:w-64 md:w-full"
          />
        </div>

        {/* Right side - Text Content */}
        <div className="w-full lg:w-2/3">
          <h1 className="text-2xl sm:text-3xl md:text-[32px] font-bold text-[#172633] uppercase leading-snug sm:leading-tight text-center lg:text-left">
            Our Founder & CEO <br /> <span className="text-black">Dr. Deepika</span>
          </h1>


          <h3 className="text-lg sm:text-xl font-semibold text-[#204356] mt-3 sm:mt-4">
            A Visionary Leader, Changemaker & Multi-Faceted Achiever
          </h3>

          <div className="mt-4 space-y-3 sm:space-y-4 text-[#204356] text-sm sm:text-base leading-relaxed text-justify">
            <p>
              Dr. Deepika is the Founder and CEO of{" "}
              <span className="font-semibold">Butterfly Groups,</span> the driving force
              behind its multidimensional growth across HR consulting, training, construction,
              interiors, and mental wellness. With a rare blend of academic brilliance,
              creative talent, and social commitment, she has built Butterfly into a
              purpose-driven enterprise that touches lives and transforms communities.
            </p>

            <p>
              A Ph.D. in Business Management and an MBA in Human Resources from Christ College,
              Bangalore, Dr. Deepika is also a certified mental health professional, educator,
              and labor law specialist. Her journey began as a faculty member in reputed
              B-schools like IBS Hyderabad and Jansons School of Business, where she taught HR,
              Organizational Behavior, and Leadership. With over 2,500 training sessions
              conducted across India, she has mentored corporate professionals, entrepreneurs,
              and students alike, leaving a lasting impact wherever she goes.
            </p>

            <p>
              Beyond business and academics, Dr. Deepika is a published author and poet, known
              for her contributions to anthologies like Fickle Minds, Love vs Lust, and Trismat.
              Her writing often reflects her deep empathy for society and her advocacy for mental
              health, gender equality, and emotional healing.
            </p>

            <p>
              In her capacity as a social service activist, Dr. Deepika has led numerous
              community initiatives—from feeding the homeless during the pandemic to building
              sanitation facilities in government schools. Her work has earned her recognition
              such as the Munnodi Penmani Award from Bharathidasan University, honoring unsung
              heroines who serve selflessly.
            </p>

            <p>
              Dr. Deepika’s entrepreneurial philosophy is rooted in balance—of mind and mission,
              heart and head. Through Butterfly Groups, she envisions a world where people don’t
              just survive, but thrive—with the right guidance, space, support, and self-belief.
            </p>
          </div>
        </div>
      </div>

      {/* Scrolling Gallery */}
      <div data-aos="fade-up" className="mb-2 py-4 text-center">
        <div className="relative hide-scrollbar">
          <div className="flex w-max space-x-2 animate-scrollLeft hover:[animation-play-state:paused]">
            {[...galleryImages, ...galleryImages].map((logo, index) => (
              <img
                key={index}
                src={logo}
                alt={`Gallery ${index}`}
                className="h-24 sm:h-32 md:h-40 w-auto  rounded-lg object-contain transition-transform duration-300 hover:scale-105"
              />
            ))}
          </div>
        </div>
      </div>

    </section>
  );
};

export default Founder;
